import {Ability, AbilityBuilder} from '@casl/ability';
import store from '../../../../../redux/store';
import {extendPermissionDownward} from '../../utils/permissions';

const ability = new Ability();

export default (action, subject) => {
  return ability.can(action, subject);
};

store.subscribe(() => {
  const {pages} = store.getState().auth;
  ability.update(defineRulesFor(pages));
});

const defineRulesFor = (pages) => {
  const {can, rules} = new AbilityBuilder();
  if (Boolean(pages)) {
    pages.forEach(page => {
      const {pageName, permissionLevel} = page;
      can(extendPermissionDownward(permissionLevel), pageName);
    })
  }

  return rules;
};
